import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
  (response) => {
    const version = localStorage.getItem('version');
    const listVersion = version?.length > 7 ? JSON?.parse(version) : version
    const versionProviders = version?.length > 7 ? listVersion?.providers_version : version
    const versionValidate = versionProviders > 4 ? JSON?.parse(versionProviders)?.length : JSON?.parse(version)?.length

    const currentVersion = response.headers?.version;
    const objectVersions = {
      catalog_version: listVersion?.catalog_version,
      auth_version: listVersion?.auth_version,
      orders_version: listVersion?.orders_version,
      manufactures_version: listVersion?.manufactures_version,
      providers_version: response.headers?.version,
      restaurants_version: listVersion?.restaurants_version,
      cache_version: listVersion?.cache_version,
    }

    if (!versionProviders || versionProviders !== currentVersion) {
      localStorage.setItem('version', JSON.stringify(objectVersions));
    }

    if (
      versionValidate &&
      versionProviders !== currentVersion &&
      versionProviders !== null &&
      versionProviders !== 'undefined' &&
      currentVersion !== undefined
    ) {
      location.reload(true);
    }

    return response;
  },
  (error) => Promise.reject(error)
);

export default instance;
